import { useSearchParams } from "react-router-dom";
import { Mail, MessageCircle, Phone } from "lucide-react";
import { useSettings } from "@/lib/api";
import { RequestForm } from "@/components/RequestForm";
import { InfoNav } from "@/pages/InfoPage";
import { IDENTITY } from "@/constants/pages";

const Card = ({ icon: Icon, label, children }) => (
  <div className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-[#F5F7FA] p-5">
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#0066FF] text-white"><Icon className="h-5 w-5" /></span>
    <div className="min-w-0 text-sm"><p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</p><div className="mt-1 text-slate-900">{children}</div></div>
  </div>
);

export const ContactCards = () => {
  const s = useSettings()?.store || {};
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="contact-cards">
      <Card icon={Phone} label="Cellulare"><a href="tel:+393791192613" className="font-semibold hover:text-[#0066FF]" data-testid="contact-phone-link">+39 379 119 2613</a></Card>
      <Card icon={Mail} label="Email"><a href="mailto:leontechshopitalia@gmail.com" className="break-all font-semibold hover:text-[#0066FF]">leontechshopitalia@gmail.com</a></Card>
      {s.whatsapp_enabled && (
        <a href="https://wa.me/393791192613" target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-btn"
          className="flex items-center justify-center gap-2 rounded-2xl bg-[#25D366] p-5 font-semibold text-white sm:col-span-2"><MessageCircle className="h-5 w-5" />Scrivici su WhatsApp</a>
      )}
      {s.hours && <Card icon={Phone} label="Orari assistenza">{s.hours}</Card>}
    </div>
  );
};

export default function ContactPage({ support = false }) {
  const [sp] = useSearchParams();
  return (
    <div className="mx-auto grid max-w-6xl gap-12 px-4 pt-12 sm:px-6 lg:grid-cols-[220px_1fr]" data-testid={support ? "support-page" : "contact-page"}>
      <InfoNav />
      <div className="min-w-0 max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#0066FF]">{support ? "Assistenza clienti" : "Contatti"}</p>
        <h1 className="mt-3 font-display text-4xl font-bold tracking-[-0.03em] text-[#0A0B0E] sm:text-5xl">{support ? "Come possiamo aiutarti?" : "Contatta LEONTECH"}</h1>
        <p className="mt-4 text-slate-500">{support ? "Apri una richiesta per ordini, spedizioni, resi, garanzia o assistenza tecnica. Puoi allegare fino a 5 fotografie." : "Scrivici per informazioni sui prodotti, ordini, spedizioni, resi e assistenza."}</p>
        <div className="mt-8"><ContactCards /></div>
        <div className="mt-10"><RequestForm defaultType={sp.get("tipo") || (support ? "assistenza" : "informazioni")} withPhotos={support} /></div>
        <div className="mt-10 rounded-2xl border border-slate-200 p-5 text-sm leading-relaxed text-slate-600" data-testid="contact-company">
          <p className="font-semibold text-slate-900">{IDENTITY}</p>
          <p className="mt-2">Titolare: Ettore Puddu · Impresa individuale · Sede: Via Atenisio Carducci Cataldantonio 10, 74121 Taranto (TA) · REA TA-208699</p>
        </div>
      </div>
    </div>
  );
}
